module.exports = __webpack_public_path__ + "static/media/apply-your-tune.d868820a.svg";